var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-badge",class:_vm.rateClass},[_c('span',{staticClass:"rate-num"},[_vm._v(_vm._s(_vm.matchRate)),_c('small',[_vm._v("%")])]),_vm._v(" "),_c('span',{staticClass:"rate-text"},[_vm._v("智能匹配")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9793b5f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/encounter/MatchRateBadge.vue
// module id = null
// module chunks = 